$(document).ready(function()
{
    $(".js-slick").slick({
        dots: true,
    });

});

